<template>
  <div class="gf_pricing__discount__box gf_pricing__container">
    <div class="gf_pricing__discount__box__left">
      <div class="gf_pricing__discount__box__left-title">
        {{ $t("dataNewPlan.discount.moreStoreMoreDiscount") }}
      </div>
      <div v-html="moreStoreMoreDiscountContent" class="gf_pricing__discount__box__left-desc">
      </div>
      <div class="gf_pricing__discount__box__left-desc-2">
        {{ $t("dataNewPlan.discount.moreStoreMoreDiscount.desc2") }}
      </div>
      <div class="gf_pricing__discount__box__left-action" @click="makeARequest()">{{ $t("pricing.requestMake") }}</div>
    </div>
    <div class="gf_pricing__discount__box__right">
      <img
        :src="$t('pricing.groupDiscountImg')"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "Pricingdiscount",
  computed: {
    ...mapState("account", {
      account: state => state.shopInfo,
    }),
    moreStoreMoreDiscountContent(){
      return this.$t('dataNewPlan.discount.moreStoreMoreDiscount.desc1', {shopifyDomain: this.account.shopifyDomain});
    }
    
  },
  methods: {
    makeARequest() {
      const url = `https://forms.clickup.com/f/3m5v4-12685/0FZ4NQI03A25VAWMFM?domain=${this.account.shopifyDomain}&shopify_email=${this.account.email}`
      window.open(url);
    }
  },
};
</script>

<style lang="scss" scoped>
.gf_pricing__discount {
  &__box {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    &__left {
      flex: 1;
      text-align: left;
      &-title {
        font-weight: 600;
        font-size: 24px;
        line-height: 36px;
        color: map-get($hybrid-shade-light, "100");
        margin-bottom: 4px;
      }
      &-desc, &-desc-2 {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: map-get($text-dark-mode, "high-contrast");
        margin-bottom: 22px;
        max-width: 336px;
      }
      &-desc-2 {
        margin-bottom: 32px;
      }
      &-action {
        cursor: pointer;
        width: 180px;
        height: 40px;
        background: map-get($hybrid-shade-light, "100");
        color: map-get($text-light-mode, "high-contrast");
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: #DCDCDC;
        }
      }
    }
    &__right {
      width: 499px;
      height: 220px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
